import template from './template.html'

function ContabilidadReporteisnComponent ($filter, $location, $moment, ContabilidadReporteisnOpciones) {
  var $ctrl = this

  $ctrl.data = {}

  $ctrl.$onInit = function () {
    $ctrl.promise = ContabilidadReporteisnOpciones.get()
      .then(function (response) {
        $ctrl.opciones = response.data
        $ctrl.opciones.empresas = $filter('orderBy')($ctrl.opciones.empresas, ['nombre'])
      })
  }

  $ctrl.$onChanges = function (changes) {
    if (changes.fechaInicial) {
      $ctrl.fechaInicial = $moment($ctrl.fechaInicial).startOf('month').toDate()
    }

    if (changes.fechaFinal) {
      $ctrl.fechaFinal = $moment($ctrl.fechaFinal).startOf('month').toDate()
    }
  }

  $ctrl.buscar = function () {
    var idEmpresa = $ctrl.idEmpresa
    var fechaInicial = $moment($ctrl.fechaInicial).startOf('month')
    var fechaFinal = $moment($ctrl.fechaFinal).endOf('month')

    $location.search({
      id_empresa: idEmpresa,
      fecha_inicial: fechaInicial.format('YYYY-MM-DD'),
      fecha_final: fechaFinal.format('YYYY-MM-DD'),
    })

    $ctrl.generando = true
  }
}

angular.module('contabilidad.reporteisn')
  .component('contabilidadReporteisn', {
    controller: ContabilidadReporteisnComponent,
    template,
    bindings: {
      idEmpresa: '<',
      fechaInicial: '<',
      fechaFinal: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/components/component.js